// card frame options for CardFrames and FramePicker

const frames = [
  {
    id: 7,
    name: 'Book Worm',
    badge: 'frames/book-worm/worm-top.webp'
  },
  {
    id: 4,
    name: 'Dead to Me',
    badge: 'frames/dead-to-me/tombstone.webp'
  },
  {
    id: 1,
    name: 'Garden Leaves',
    badge: 'frames/garden-leaves/flower.webp'
  },
  {
    id: 5,
    name: 'Lil Guys',
    badge: 'frames/lil-guys/pot-sitting.webp'
  },
  {
    id: 2,
    name: 'Magical Helper',
    badge: 'frames/magical-helper/hat.webp'
  },
  {
    id: 6,
    name: 'Pen Pals',
    badge: 'frames/pen-pals/icon.webp'
  },
  {
    id: 3,
    name: 'Tea Time',
    badge: 'frames/tea-time/pot.webp'
  }
]

export default frames
